import { FORM_ERROR } from 'final-form';

export default onSubmit => (...args) => Promise.resolve(onSubmit(...args))
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error(err);
    return { [FORM_ERROR]: err };
  });
